export default __webpack_public_path__ + "static/media/enviro-car.32d479a3.png";